import dimensions from 'shared/styles/dimensions'
import styled from 'styled-components'

import { colors } from '../../styles/colors'
import { ITextProps } from './TextComponent.types'

export const Container = styled.div<ITextProps>`
  font-family: 'Roboto';
  font-style: ${({ fontStyle }) => fontStyle ?? 'normal'};
  font-size: ${({ size }) => size || dimensions.fontSize.medium}px;
  font-weight: ${({ weight }) => weight ?? 'normal'};
  color: ${({ color }) => color ?? colors.blue};
`
